import { Col, Container, Image, Row } from "react-bootstrap";

const DataProcessingAgreementHidden = () => {
  return (
    <Container className="w-100 main-container container">
      <Container className="body-text">
        <Container className="mb-4">
          <p>
            This DPA (including its schedules) is entered into pursuant to the
            JLP Insights & Media Terms & Conditions between you (<b>“you”</b>
            or <b>“Supplier”</b>) and John Lewis plc (<b>“John Lewis”</b>,
            <b>“we”</b> or <b>“us”</b>) relating our provision of Retail Media
            services to you.
          </p>
        </Container>
        <Container className="mb-4">
          <p>
            Unless otherwise agreed between you and us in writing and to the
            extent that the Retail Media services include providing you with
            Personal Data in respect of which John Lewis is the data controller
            for the purposes of delivering Samples or any Campaign Material
            directly to John Lewis’ customers (the delivery of Samples or any
            Campaign Material directly to John Lewis’ customers being the
            <b>“Services”</b> for the purposes of this DPA), you and John Lewis
            have agreed that the terms of the DPA shall be incorporated into the
            JLP Insights & Media Terms & Conditions. The Definitions in Schedule
            1 shall apply to this DPA.
          </p>
        </Container>
        <Container className="mb-4">
          <p className="mb-2">
            <b>Terms and Conditions</b>
          </p>
          <p className="mb-2">
            Under the Data Protection Laws, it is a requirement that controllers
            impose certain contractual obligations upon their processors.
          </p>
          <p className="mb-2">
            The Services provided by you will necessarily involve the processing
            of personal data on our behalf and therefore, in the case of our
            relationship with you and your processing of the personal data in
            connection with the Services, John Lewis will be the controller and
            you (and each permitted sub-processor under this letter) will be the
            processor.
          </p>
          <p className="mb-2">
            This letter sets out the terms on which we will provide you with the
            personal data in relation to the Services. Nothing in this letter or
            Clause 1 below relieves you from obligations imposed upon you under
            the Data Protection Laws.
          </p>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>1</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Supplier obligations and warranties</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={10}>
              <p>
                You warrant and undertake to John Lewis that you shall, and
                shall procure that your sub- contractors shall:
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.1</Col>
            <Col md={9}>
              <p>
                only process personal data in compliance with, and shall not
                cause yourself or John Lewis or any Customer Affiliate to be in
                breach of, the Data Protection Laws;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.2</Col>
            <Col md={9}>
              <p>
                use the personal data, which is set out in Schedule 2 of this
                letter, only as specified in that Schedule for the purposes of
                providing the Services and not for any other purpose;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.3</Col>
            <Col md={9}>
              <p className="mb-2">
                only process the personal data on the documented instructions of
                John Lewis (and for the avoidance of doubt, such documented
                instructions include as provided by this letter), including with
                regard to transfers of personal data to a third country or
                international organisation, and otherwise:
              </p>
              <p className="mb-2">
                (i) as necessary to perform your obligations in providing the
                Services; or
              </p>
              <p className="mb-2">
                (ii) as required by any Applicable Law of which, before
                processing any personal data, you shall notify John Lewis
                (unless prohibited by Applicable Law from doing so on important
                grounds of public interest).
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.4</Col>
            <Col md={9}>
              <p>
                keep a record of the documented instructions of John Lewis,
                including as provided by this letter;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.5</Col>
            <Col md={9}>
              <p>
                comply with any request from John Lewis requiring you to amend,
                transfer or delete all or any part of the personal data as soon
                as possible.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Sub-contracting and transfers to third parties</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.6.1</Col>
            <Col md={9}>
              <p className="mb-2">
                not engage or transfer and/or disclose any personal data to any
                other processor, sub- contractor or other third party, including
                a Supplier Affiliate to carry out processing in connection with
                the Services (<b>"sub-processor"</b>) (including any cloud
                computing service providers or contractors):
              </p>
              <p className="mb-2">
                (i) unless the engagement is necessary for you to carry out the
                Services; and
              </p>
              <p className="mb-2">
                (ii) without the prior specific written authorisation of John
                Lewis.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.6.2</Col>
            <Col md={9}>
              <p className="mb-2">with respect to each sub-processor:</p>
              <p className="mb-2">
                (i) carry out adequate due diligence to ensure the sub-processor
                is capable of providing a level of protection for the personal
                data as required by this letter; and
              </p>
              <p className="mb-2">
                (ii) provide John Lewis for review such copies of the agreements
                with sub-processors (which may be redacted to remove
                confidential commercial information not relevant to the
                requirements of this letter) as John Lewis may request from time
                to time.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.6.3</Col>
            <Col md={9}>
              <p className="mb-2">
                enter into a written agreement with each sub-processor approved
                by John Lewis under Clause 1.6.1 containing obligations on such
                third party which are equivalent to, and no less onerous than,
                those set out in this letter and you shall remain responsible to
                John Lewis for all obligations that are performed by and acts or
                omissions of each sub- processor authorised by John Lewis under
                Clause 1.6.1 as if they were your acts and omissions. This
                Clause shall also apply to any replacement sub-processor.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Confidentiality</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.7</Col>
            <Col md={9}>
              <p className="mb-2">
                maintain the confidentiality of the personal data and not
                disclose, copy, reproduce or distribute any of it or otherwise
                make it available to any third party except in response to a
                specific written request by John Lewis or where obliged to do so
                by law and, in the case of the latter, promptly notify John
                Lewis and cooperate with us in the making of such disclosure;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.8</Col>
            <Col md={9}>
              <p className="mb-2">
                take all reasonable steps to ensure the reliability of any
                employees, agents or contractors who may have access to, or are
                authorised to process, personal data and ensure such employees,
                agents or contractors are bound by obligations of
                confidentiality which are no less protective than those set out
                in this letter and shall ensure that such access is strictly
                limited to those employees, agents and contractors requiring
                access for provision of the Services and that they at all times
                act in compliance with Data Protection Laws and the obligations
                of this letter;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.9</Col>
            <Col md={9}>
              <p className="mb-2">
                procure that those of your employees, agents or contractors who
                are used to provide the Services are made aware (in advance of
                disclosure) of the terms of this letter, and will use best
                endeavours to procure that each such person adheres to those
                terms as if that person were a party to this letter;
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Dealings with supervisory authorities and others</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.10.1</Col>
            <Col md={9}>
              <p className="mb-2">
                notify John Lewis immediately, if you receive any enquiry,
                rights or other request, complaint, notice or other
                communication from any supervisory authority, other
                organisation, any data subject or any individual, relating to
                either the Services or sub- processors or other third parties
                who are appointed by you in connection with the Services or our,
                your or any sub-processor's compliance with Data Protection
                Laws, unless prohibited by Applicable Law.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.10.2</Col>
            <Col md={9}>
              <p className="mb-2">
                provide all necessary assistance to John Lewis to enable us to
                respond to such enquiries, rights or other requests, complaints,
                notices or other communications and to comply with Data
                Protection Laws.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.10.3</Col>
            <Col md={9}>
              <p className="mb-2">
                not respond to any enquiry, rights or other request, complaint,
                notice or other communication without the prior written consent
                of John Lewis.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Security</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.11.1</Col>
            <Col md={9}>
              <p className="mb-2">
                have in place and maintain Protective Measures regarding the
                security of the personal data, including without limitation:
              </p>
              <p className="mb-2">
                (i) protection against unauthorised disclosure of, or access to;
                and
              </p>
              <p className="mb-2">
                (ii) protection against accidental or unlawful destruction, loss
                or alteration;
              </p>
              <p className="mb-2">
                of personal data transmitted, stored or otherwise processed.
              </p>
              <p className="mb-2">
                and shall comply with John Lewis' IT security policies and
                provide, on our request, a written description of the technical
                and organisational measures, including Protective Measures,
                employed by you for processing of personal data within
                timescales reasonably required by John Lewis. Compliance with
                John Lewis' IT security policies shall not relieve you of any
                liability otherwise arising under this letter and shall not
                constitute confirmation or assurance from John Lewis that
                compliance with the requirements set out in John Lewis' IT
                security policies shall satisfy your other obligations under
                this letter or under Data Protection Laws regarding the security
                of personal data.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.11.2</Col>
            <Col md={9}>
              <p className="mb-2">
                take all measures required by, and provide all reasonable
                assistance to John Lewis so that it can demonstrate compliance
                with Article 32 of the GDPR, and assist John Lewis by
                appropriate technical and organisational security measures to
                ensure the processing of personal data meets the requirements of
                the Data Protection Laws and for the fulfilment of our
                obligations to respond to requests for exercising the rights of
                data subjects as set out in the Data Protection Laws.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Data breaches</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.1</Col>
            <Col md={9}>
              <p className="mb-2">
                notify John Lewis immediately in writing after becoming aware of
                any:
              </p>
              <p className="mb-2">(i) Data Breach or</p>
              <p className="mb-2">
                (ii) protection against accidental or unlawful destruction, loss
                or alteration;
              </p>
              <p className="mb-2">
                (ii) any other breach of the terms of this letter.
              </p>
              <p className="mb-2">
                <b>
                  Failure to notify John Lewis shall be deemed an irremediable
                  material breach of the agreement between John Lewis and you
                  under which you provide the Services.
                </b>
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.2</Col>
            <Col md={9}>
              <p className="mb-2">
                in the event of a Data Breach, provide John Lewis with full
                co-operation and assistance in dealing with the Data Breach, in
                particular in relation to:
              </p>
              <p className="mb-2">
                (i) resolving any data privacy or security issues involving any
                personal data; and
              </p>
              <p className="mb-2">
                (ii) making any appropriate notifications to individuals
                affected by the Data Breach or to a supervisory authority.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.3</Col>
            <Col md={9}>
              <p className="mb-2">
                investigate the Data Breach immediately and in any event within
                24 hours and shall then provide John Lewis as soon as possible
                with complete information relating to a Data Breach, including,
                without limitation:
              </p>
              <p className="mb-2">(i) the nature of the Data Breach;</p>
              <p className="mb-2">
                (ii) the nature of the personal data affected;
              </p>
              <p className="mb-2">
                (iii) the categories and number of data subjects concerned;
              </p>
              <p className="mb-2">
                (iv) the categories and number of personal data records
                concerned;
              </p>
              <p className="mb-2">
                (v) the name and contact details of your Data Protection Officer
                or relevant contact point;
              </p>
              <p className="mb-2">
                (vi) the possible consequences of the Data Breach;
              </p>
              <p className="mb-2">
                (vii) the measures taken to, or proposed to be taken, to address
                the Data Breach and mitigate its possible effects; and
              </p>
              <p className="mb-2">
                (viii) any other information that John Lewis may reasonably
                request concerning the Data Breach.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.4</Col>
            <Col md={9}>
              <p className="mb-2">
                maintain a log of Data Breaches including facts, effects and
                remedial action taken.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.5</Col>
            <Col md={9}>
              <p className="mb-2">
                if any of the personal data in your possession or control
                becomes lost, corrupted or rendered unusable for any reason
                (including as a result of the Data Breach), shall promptly take
                all steps to restore, re-constitute and/or reconstruct any
                personal data using your back up and/or disaster recovery
                procedures as if they were your own data at your own cost with
                all possible speed and shall provide John Lewis with all
                reasonable assistance in respect of it at no cost to John Lewis.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.12.6</Col>
            <Col md={9}>
              <p className="mb-2">
                take all steps necessary to prevent a repeat of the Data Breach
                and shall consult with and agree those steps with John Lewis.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Information and data audits</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.13.1</Col>
            <Col md={9}>
              <p className="mb-2">
                on request and at no additional charge, provide to John Lewis
                and/or its authorised representatives or auditors all
                information required by John Lewis and/or allow for and
                contribute to audits and inspections to assess your compliance
                with this letter and the Data Protection Laws and all
                information necessary for John Lewis to demonstrate our
                compliance with the Data Protection Laws.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.13.2</Col>
            <Col md={9}>
              <p className="mb-2">
                in order that John Lewis and/or its authorised representatives
                or auditors and any supervisory authority may audit your
                compliance with the Data Protection Laws and the terms of this
                letter, on request and at no additional charge you shall provide
                John Lewis with:
              </p>
              <p className="mb-2">
                (i) reasonable access to all relevant data processing
                facilities, procedures and documentation and all information,
                premises, personal data, employees, agents, sub- processors,
                equipment and assets at all locations from which your
                obligations under this letter are being or have been or should
                have been carried out;
              </p>
              <p className="mb-2">
                (ii) all reasonable assistance in carrying out the audit, and
              </p>
              <p className="mb-2">
                (iii) shall notify John Lewis immediately if, in your opinion,
                an instruction under Clause 1.13.1 or 1.13.2 infringes the Data
                Protection Laws or any other Applicable Law.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>

            <Col md={10}>
              <p className="mb-2">
                Clause 1.13.1 and 1.13.2 apply during the terms of the delivery
                of the Services and for 36 months after the termination date of
                the Services, subject to John Lewis giving you seven days'
                notice (except where such audit is required by a supervisory
                authority to which John Lewis is subject in which case these
                time limits shall not apply).
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Data subjects</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.14.1</Col>
            <Col md={9}>
              <p className="mb-2">
                on request, take all necessary actions and provide John Lewis
                with all reasonable assistance necessary for us to comply with
                our obligations under the Data Protection Laws, including in
                relation to:
              </p>
              <p className="mb-2">
                (i) the provision of access to information and personal data to
                data subjects;
              </p>
              <p className="mb-2">
                (ii) the rectification of inaccurate data in relation to a data
                subject;
              </p>
              <p className="mb-2">
                (iii) the erasure of a data subject's personal data;
              </p>
              <p className="mb-2">
                (iv) the restriction of processing of personal data of a data
                subject;
              </p>
              <p className="mb-2">
                (v) the right of a data subject to object to processing of their
                personal data including automated decision-making; and
              </p>
              <p className="mb-2">
                (vi) the retrieval and porting of the personal data of a data
                subject.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Data Minimisation</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.15</Col>
            <Col md={9}>
              <p className="mb-2">
                shall use reasonable information minimisation procedures to
                limit collection, retention and processing of personal data.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Assistance and co-operation</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.16</Col>
            <Col md={9}>
              <p className="mb-2">
                shall provide John Lewis with such assistance and co-operation
                as we may reasonably request to enable us to comply with any
                obligations imposed on us by Data Protection Laws in relation to
                the personal data processed by you, including, but not limited
                to:
              </p>
              <p className="mb-2">
                (i) on request of John Lewis, promptly providing written
                information regarding the technical and organisational measures,
                including Protective Measures, which you have implemented to
                safeguard the personal data in compliance with this letter
                and/or Data Protection Laws;
              </p>
              <p className="mb-2">
                (ii) disclosing full and relevant details in respect of any and
                all government access controls which you have implemented; and
              </p>
              <p className="mb-2">
                (iii) notifying John Lewis as soon as possible and as far as you
                are legally permitted to do so, of any request for disclosure of
                data which concerns personal data (or any part thereof) by any
                governmental or other regulatory authority, or by a court or
                other competent authority. For the avoidance of doubt and as far
                as you are legally permitted to do so, you shall not disclose or
                release any personal data in response to such request without
                first consulting with and obtaining the written consent of John
                Lewis.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.17</Col>
            <Col md={9}>
              <p className="mb-2">
                if requested in writing by John Lewis from time to time, provide
                to us a copy of the personal data in the format and on the media
                reasonably specified;
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Records</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.18.1</Col>
            <Col md={9}>
              <p className="mb-2">
                maintain records of all processing activities carried out on
                behalf of John Lewis to comply with Data Protection Laws,
                including:
              </p>
              <p className="mb-2">
                (i) the information described in Clauses 1.13.1 and 1.13.2;
              </p>
              <p className="mb-2">
                (ii) where applicable, the name and contact details of: your
                company, John Lewis, any sub-processors and the data protection
                officer or, if relevant, the representative based in the EEA of
                your company and of any sub-processors;
              </p>
              <p className="mb-2">
                (iii) the different types of processing being carried out (if
                applicable);
              </p>
              <p className="mb-2">
                (iv) any transfers of personal data outside of the EEA,
                including the identification of the relevant country or
                international organisation and any documentation required to
                demonstrate suitable safeguards;
              </p>
              <p className="mb-2">
                (v) a description of the Protective Measures referred to in
                Clauses 1.11.1 and 1.11.2, together, <b>"the Records"</b>. The
                Records shall be in written electronic form.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.18.2</Col>
            <Col md={9}>
              <p className="mb-2">
                provide the Records to John Lewis promptly on request in a
                format reasonably requested by us.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Transfers outside of the EEA</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.19</Col>
            <Col md={9}>
              <p className="mb-2">
                not transfer any personal data outside the EEA, or to any
                international organisation unless:
              </p>
              <p className="mb-2">
                (i) you notify John Lewis in writing that you intend to transfer
                any personal data outside of the EEA;
              </p>
              <p className="mb-2">
                (ii) John Lewis provides its written consent to such transfer
                (which consent it may give or withhold in its absolute
                discretion or make subject to conditions); and
              </p>
              <p className="mb-2">
                (iii) you provide, in advance of a transfer authorised under
                Clause 1.19(ii) evidence to John Lewis's satisfaction of
                appropriate safeguards, as required by Data Protection Laws.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Return, destruction and disposal of data</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.20</Col>
            <Col md={9}>
              <p className="mb-2">
                shall, on the termination or expiry of the agreement (or the
                relevant part of it) between you and John Lewis, at the option
                of John Lewis:
              </p>
              <p className="mb-2">
                (i) securely destroy or delete all personal data (including any
                personal data held in an electronic database) within 30 days and
                confirm such destruction or deletion in writing to John Lewis;
                or
              </p>
              <p className="mb-2">
                (ii) return to John Lewis or transfer all personal data to a
                nominated third party, in a mutually agreed form and format and
                by a mutually agreed method and shall destroy or delete all
                personal data (including any personal data held in an electronic
                database) within 30 days and confirm such destruction or
                deletion in writing to John Lewis;
              </p>
              <p className="mb-2">
                other than to the extent that its ongoing retention by you is
                required by Applicable Law.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.21</Col>
            <Col md={9}>
              <p className="mb-2">
                not, and shall ensure that no third party appointed to assist in
                the provision of the Services shall, dispose, re-assign or
                re-use any equipment or any electronic, magnetic or other medium
                which is or has been used to store personal data or any other
                data that has been generated, obtained, held, used or stored for
                the purposes of the Services without ensuring that such personal
                data has been entirely removed, or otherwise securely
                obliterated.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b></b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Data protection impact assessments</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.22.1</Col>
            <Col md={9}>
              <p className="mb-2">
                notify John Lewis, prior to adopting any new type of processing
                in respect of personal data (including, without limitation, the
                use of new technology or processes to continue current
                processing).
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>1.22.2</Col>
            <Col md={9}>
              <p className="mb-2">
                following notification by you under Clause 1.22.1, at John
                Lewis's request shall participate in, and provide all reasonable
                assistance with, a privacy impact assessment, data protection
                impact assessment or prior consultation with a supervisory
                authority including under Article 35 (data protection impact
                assessment) and Article 36 (prior consultation) of the GDPR or
                equivalent provisions of Data Protection Laws in respect of the
                new type of processing proposed, in accordance with Data
                Protection Laws.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>2</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>General</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.1.1</Col>
            <Col md={9}>
              <p>
                You shall on demand indemnify John Lewis from and against all
                costs, claims, actions, proceedings, demands, awards, judgments,
                settlements, expenses, liabilities, damages and losses
                (including all interest, fines, penalties, legal costs and
                disbursements, loss or corruption of data, management time, loss
                of reputation, goodwill) of whatsoever nature incurred by John
                Lewis or member of its group in connection with any failure by
                you or any sub-processor or other third party appointed by you
                to comply with the provisions of this letter and/or Data
                Protection Laws in respect of your processing of personal data.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.1.2</Col>
            <Col md={9}>
              <p>
                No exclusions or limitations of liability whatsoever shall apply
                to the indemnity given by you in Clause 2.1.1.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.2</Col>
            <Col md={9}>
              <p>
                You acknowledge and agree that John Lewis retains all rights,
                title and interest in the personal data, including any copyright
                and database rights.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.3</Col>
            <Col md={9}>
              <p>
                This letter (including the agreement constituted by your
                acknowledgement of its terms) and the relationship between the
                parties shall be governed by and construed in accordance with
                the laws of England and Wales.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.4</Col>
            <Col md={9}>
              <p>
                The English courts have exclusive jurisdiction to settle any
                disputes arising out of or in connection with this letter and
                the parties submit to the exclusive jurisdiction of the English
                courts.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.5.1</Col>
            <Col md={9}>
              <p>
                To the extent that you have an entitlement under Data Protection
                Laws to claim from John Lewis compensation paid by you to a data
                subject as a result of a breach of Data Protection Laws to which
                John Lewis contributed, we shall be liable only for such amount
                as it directly relates to our responsibility for any damage
                caused to the relevant data subject.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}></Col>
            <Col md={1}>2.5.2</Col>
            <Col md={9}>
              <p>
                For the avoidance of doubt John Lewis shall only be liable to
                make payment to you under Clause 2.5.1 upon receipt of evidence
                from you, to John Lewis's reasonable satisfaction, that clearly
                demonstrates:
              </p>
              <p>(i) John Lewis has breached Data Protection Laws;</p>
              <p>
                (ii) that such breach contributed (in part or in full) to the
                harm caused and entitling the relevant data subject to receive
                compensation in accordance with Data Protection Laws; and
              </p>
              <p>
                (iii) the compensation payable reflects the proportion of
                responsibility for the harm caused to the relevant data subject
                which is attributable to John Lewis.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3 text-center">
            <Col className="mb-2">
              <b>SCHEDULE 1: Definitions</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={12}>
              <p className="mb-2">
                <b>"Applicable Law"</b> means all applicable EU laws,
                regulations, regulatory requirements and codes of practice as
                amended and in force from time to time.
              </p>
              <p className="mb-2">
                <b>"Customer Affiliate"</b> means any entity which owns or
                controls, is owned or controlled by or is under common control
                or ownership with John Lewis where control is defined as the
                possession, directly or indirectly, of the power to direct or
                cause the direction of the affairs of an entity, whether through
                ownership of voting securities, by contract or otherwise.
              </p>
              <p className="mb-2">
                <b>"Data Breach"</b> means any event that results, or may result
                in, unauthorised or unlawful processing of, disclosure of, use
                of, access to, theft of and/or any accidental or unlawful damage
                to, destruction of, loss of, alteration to or corruption of
                personal data.
              </p>
              <p className="mb-2">
                <b>"Data Protection Law"</b> means:
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={1}></Col>
            <Col md={1}>(a)</Col>
            <Col md={10}>
              <p className="mb-2">
                the European Data Protection Directive (95/46/EC) and the
                European Privacy and Electronic Communications Directive
                (Directive 2002/58/EC), including as transposed into the
                domestic law of each Member State;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={1}></Col>
            <Col md={1}>(b)</Col>
            <Col md={10}>
              <p className="mb-2">
                on and from 25 May 2018, Regulation (EU) 2016/679 on the
                protection of natural persons with regard to the processing of
                personal data and on the free movement of such data, and
                repealing Directive 95/46/EC (General Data Protection
                Regulation) <b>("the GDPR")</b> and any law implementing,
                supplementing, replacing or relating to it;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={1}></Col>
            <Col md={1}>(c)</Col>
            <Col md={10}>
              <p className="mb-2">
                on and from the date it becomes applicable, the Regulation on
                Privacy and Electronic Communications and any law implementing,
                supplementing, replacing or relating to it;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={1}></Col>
            <Col md={1}>(d)</Col>
            <Col md={10}>
              <p className="mb-2">
                any guidance, directions, determinations, codes of practice,
                orders, notices or demands issued by any supervisory authority
                or other competent authority;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={1}></Col>
            <Col md={1}>(e)</Col>
            <Col md={10}>
              <p className="mb-2">
                the Data Protection Act 2018 (when in force) and any other
                applicable data privacy or data protection laws or regulations
                and judgments of any tribunal, regulatory body or court of law;
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={12}>
              <p className="mb-2">
                each as amended, extended, re-enacted or replaced from time to
                time.
              </p>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={12}>
              <p className="mb-2">
                The terms
                <b>
                  "personal data", "controller", "processor", "data subject",
                  "processing", "supervisory authority", "Member State", "third
                  country"
                </b>
                and <b>"international organisation"</b>shall all have the same
                meaning as in the Data Protection Laws and the term{" "}
                <b>"process"</b> shall be construed accordingly.
              </p>
              <p className="mb-2">
                <b>"EEA"</b> means the European Economic Area.
              </p>
              <p className="mb-2">
                <b>"Protective Measures"</b> means all appropriate technical and
                organisational measures aimed at ensuring an appropriate level
                of security and preventing a Data Breach, which shall be
                compliant with all appropriate Data Protection Laws including
                but not limited to preventing a breach resulting from, or
                arising out of, your internal use, processing or other
                transmission of personal data.
              </p>
              <p className="mb-2">
                <b>"Sub-processor"</b> has the meaning set out in Clause 1.6.1.
              </p>
              <p className="mb-2">
                <b>"Supplier Affiliate"</b> means any entity which owns or
                controls, is owned or controlled by or is under common control
                or ownership with you, where control is defined as the
                possession, directly or indirectly, of the power to direct or
                cause the direction of the affairs of an entity, whether through
                ownership of voting securities, by contract or otherwise.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3 text-center">
            <Col className="mb-2">
              <b>SCHEDULE 2: Information required by the GDPR</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={12}>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td>
                      <b>Subject matter of processing </b>
                    </td>
                    <td>
                      <i>my John Lewis Review Panel</i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Duration of processing </b>
                    </td>
                    <td>
                      <i>For delivery purposes only</i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Purpose and nature of processing </b>
                    </td>
                    <td>
                      <i>For delivery purposes only</i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Type of personal data </b>
                    </td>
                    <td>
                      <i>Name, address, phone number, email address</i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Categories of data subjects </b>
                    </td>
                    <td>
                      <i>Customers - my JL review panel members</i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

export default DataProcessingAgreementHidden;
